<template>
  <v-container>
    <h3 class="text-center">Logo panelu logowania</h3>
    <v-divider class="my-4" />
    <v-img
      :src="bigLogo"
      lazy-src="@/assets/image-placeholder.png"
      class="grey lighten-2"
      contain
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <template v-if="hover" v-slot:default>
        <v-row class="fill-height ma-0 darken" align="center" justify="center">
          <div>
            <v-btn color="gray" @click="startUploadImage">Edytuj</v-btn>
          </div>
        </v-row>
      </template>
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    <ImageUpload :show="showUpload" title="Prześlij obraz" @close="showUpload = false" @uploaded="uploadImage" />
  </v-container>
</template>

<script>
import ImageUpload from '@/components/shared/ImageUpload.vue';
import MediaApi from '@/api/mediaApi';
import { createNamespacedHelpers } from 'vuex';
import eventBus from '@/services/eventBus.js';

const { mapState, mapActions } = createNamespacedHelpers('appSettings');

export default {
  components: {
    ImageUpload
  },
  data: function() {
    return {
      hover: false,
      showUpload: false
    };
  },
  computed: mapState({
    bigLogo: state => state.bigLogo || require('@/assets/big-logo-placeholder.png')
  }),
  methods: {
    ...mapActions(['saveBigLogo']),
    startUploadImage() {
      this.showUpload = true;
    },
    async uploadImage(ev) {
      new MediaApi(this.token).get(ev.url).then(
        async response => {
          await this.saveBigLogo({
            logoUri: ev.url,
            logo: response.data.result
          });

          eventBus.$emit('smallLogoChanged');
        },
        err => {
          console.error(err);
          // TODO: handle
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.darken {
  background: rgba(0, 0, 0, 0.5);
}
</style>
